import { get } from 'lodash'

export const headers = (intl = {}) => [
  intl.formatMessage({
    id: 'table.id'
  }),
  intl.formatMessage({
    id: 'table.name'
  }),
  intl.formatMessage({
    id: 'table.nao'
  }),
  intl.formatMessage({
    id: 'table.operating_authorities'
  })
]

export const line = (data = []) =>
  data.map(item => {
    return {
      line: [
        item.globalId || item.id,
        get(item, 'name'),
        get(item, 'parentNAO.name'),
        get(item, 'parentOA.name')
      ]
    }
  })
